import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getValuesFromLocalstorage } from '../../Helpers';

const ProtectedRoute = () => {
  const location = useLocation();
  const userDetails = getValuesFromLocalstorage('userDetails');
  const expiry = getValuesFromLocalstorage("expiry");

  useEffect(() => {
    if (userDetails?.acctType) {
      const userType = userDetails.acctType.toUpperCase();
      if (userType !== "ADMIN") {
        localStorage.clear();
      }
    } else {
      localStorage.clear();
    }
  }, [location.pathname]);

  const isValidUser = userDetails?.acctType?.toUpperCase() === "ADMIN";

  return expiry && userDetails && location.pathname !== "/passwordExpired" 
    ? <Navigate to="/passwordExpired" /> 
    : userDetails && isValidUser 
      ? <Outlet /> 
      : <Navigate to="/login" />;
};

export default ProtectedRoute;
 